import React from "react";
import PropTypes from "prop-types";
import { Button } from "antd";

import { PageModeTypes } from "./PageModeTypes";
import { IconLight } from "../";

const buttonDefaultProps = {
  size: "large",
  style: {
    width: "50%",
    borderRadius: 0
  }
};

const PageModes = ({ selectedMode, onModeChange }) => {
  const onClickButton = pageMode => () => {
    onModeChange(pageMode);
  };

  return (
    <div
      style={{
        marginTop: "-10px",
        marginLeft: "-10px",
        marginRight: "-10px",
        marginBottom: "10px"
      }}
    >
      <Button
        type={selectedMode === PageModeTypes.Catalogue ? "primary" : "default"}
        {...buttonDefaultProps}
        onClick={onClickButton(PageModeTypes.Catalogue)}
      >
        <IconLight icon={"chart-area"} /> Catalogue
      </Button>
      <Button
        type={selectedMode === PageModeTypes.DIY ? "primary" : "default"}
        {...buttonDefaultProps}
        onClick={onClickButton(PageModeTypes.DIY)}
      >
        <IconLight icon={"pencil-ruler"} /> DIY
      </Button>
    </div>
  );
};

PageModes.propTypes = {
  onModeChange: PropTypes.func.isRequired,
  selectedMode: PropTypes.string.isRequired
};

export default PageModes;



// WEBPACK FOOTER //
// ./src/views/components/page_modes/PageModes.jsx